import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-220b34d5"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "modal-overlay"
}
const _hoisted_2 = { class: "modal" }
const _hoisted_3 = { class: "modal-header" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "알림", -1))
const _hoisted_5 = { class: "modal_close" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "modal-content" }, " 삭제하시겠습니까? ", -1))
const _hoisted_7 = {
  key: 1,
  class: "modal-overlay"
}
const _hoisted_8 = { class: "modal" }
const _hoisted_9 = { class: "modal-header" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "알림", -1))
const _hoisted_11 = { class: "modal_close" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "modal-content" }, " 수정하시겠습니까? ", -1))
const _hoisted_13 = { class: "wrap_screen" }
const _hoisted_14 = { class: "status_bar" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "other_profile" }, " 아바타 페르소나 수정 ", -1))
const _hoisted_16 = { class: "scroll" }
const _hoisted_17 = { class: "wrap_chat_screen" }
const _hoisted_18 = { class: "persona-form" }
const _hoisted_19 = { class: "form-group" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "선택하세요", -1))
const _hoisted_21 = { class: "form-group" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "world" }, "살고 있는 세계", -1))
const _hoisted_23 = { class: "form-group" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "era" }, "시대", -1))
const _hoisted_25 = { class: "form-group" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "place" }, "장소", -1))
const _hoisted_27 = { class: "form-group" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "happenings" }, "해프닝", -1))
const _hoisted_29 = { class: "form-group" }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "name" }, "이름", -1))
const _hoisted_31 = { class: "form-group" }
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "age" }, "나이", -1))
const _hoisted_33 = { class: "form-group" }
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "tribe" }, "종족", -1))
const _hoisted_35 = { class: "form-group" }
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "gender" }, "성별", -1))
const _hoisted_37 = { class: "form-group" }
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "work" }, "하는 일", -1))
const _hoisted_39 = { class: "form-group" }
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "goal" }, "인생목표", -1))
const _hoisted_41 = { class: "form-group" }
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "value" }, "가치관", -1))
const _hoisted_43 = { class: "form-group" }
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "motivation" }, "동기부여", -1))
const _hoisted_45 = { class: "form-group" }
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "personality" }, "성격", -1))
const _hoisted_47 = { class: "form-group" }
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "mbti" }, "MBTI", -1))
const _hoisted_49 = { class: "form-group" }
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "favorite" }, "좋아하는 것", -1))
const _hoisted_51 = { class: "form-group" }
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "specialty" }, "특기", -1))
const _hoisted_53 = { class: "form-group" }
const _hoisted_54 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "topic" }, "주제", -1))
const _hoisted_55 = { class: "form-group" }
const _hoisted_56 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "speaking_habits" }, "말하는 습관", -1))

import {
  ref,
  onMounted,
  onUnmounted,
  computed,
} from 'vue';
import { notification as AntNotification } from 'ant-design-vue/lib/components';
import type { SelectProps } from 'ant-design-vue';
import { Modal } from 'ant-design-vue';
import {
  tabStore,
  userStore,
  tutorialStore,
} from '../stores/storeAuth';
import { pushPage } from '@utils/route.helper';
import router from '@router';
import { errorType } from '@interface/error';
import {
  postAvatar,
  requestGetAvatarList,
  getAvatarDetail,
  deleteAvatar,
  putAvatarInfo,
} from '@apis/voicechat';


export default /*#__PURE__*/_defineComponent({
  __name: 'PersonaEdit',
  setup(__props) {

const personaMessages = ref([]);
const messageInput = ref('');
const isListening = ref(false);

const showModal = ref(false);
const showEditModal = ref(false);
const tabData = tabStore();
const showMobileMenu = () => {
  tabData.sideMenu = true;
};
const closeModal = () => {
  showModal.value = false;
};

const openModal = () => {
  showModal.value = true;
};

const closeEditModal = () => {
  showEditModal.value = false;
};

const openEditModal = () => {
  showEditModal.value = true;
};

const persona = ref('');
const personaList = ref<SelectProps['options']>([{
  value: '',
  label: '--- 선택 ---',
}]);

// avatar 불러와서 셀렉트에 추가
const getAvatar = async () => {
  try {
    const result = await requestGetAvatarList(); // Corrected function name
    result.data.avatars.forEach((res: any) => {
      const temp = {
        value: res.id,
        label: res.name,
      };
      personaList.value.push(temp);
    });
  } catch (error) {
    console.log(error);
  }
};

const selectedAvatarDetail = ref(
  {
    world: '',
    era: '',
    place: '',
    happenings: '',
    name: '',
    age: '',
    tribe: '',
    gender: '',
    work: '',
    goal: '',
    value: '',
    motivation: '',
    personality: '',
    mbti: '',
    favorite: '',
    specialty: '',
    topic: '',
    speaking_habits: '',
  },
);
const getSelectedAvatar = async (avatarId: number) => {
  const result = await getAvatarDetail(avatarId);
  selectedAvatarDetail.value = result.data;
};

const personaHandleChange = async () => {
  console.log(persona.value);
  const result = getSelectedAvatar(persona.value);
};

const editInfo = async () => {
  try {
    const result = await putAvatarInfo(persona.value, selectedAvatarDetail.value);
    console.log(result);
    showEditModal.value = false;
    AntNotification.success({ message: '아바타 페르소나를 수정했습니다.' });
    await getAvatar();
  } catch (error) {
    // AntNotification.error({ message: error?.message });
  }
};

const deleteInfo = async () => {
  await deleteAvatar(persona.value);
  showModal.value = false;
  // await getAvatar();
  router.go(0);
  // });
};

onMounted(async () => {
  await getAvatar();
});

return (_ctx: any,_cache: any) => {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_a_select = _resolveComponent("a-select")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (showModal.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _hoisted_4,
              _createElementVNode("div", _hoisted_5, [
                _createVNode(_component_font_awesome_icon, {
                  icon: "fa-solid fa-xmark",
                  onClick: closeModal
                })
              ])
            ]),
            _hoisted_6,
            _createElementVNode("div", { class: "wrap_button" }, [
              _createElementVNode("div", {
                class: "button_okay",
                onClick: deleteInfo
              }, " 삭제 "),
              _createElementVNode("div", {
                class: "modal_cancel",
                onClick: closeModal
              }, " 취소 ")
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (showEditModal.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _hoisted_10,
              _createElementVNode("div", _hoisted_11, [
                _createVNode(_component_font_awesome_icon, {
                  icon: "fa-solid fa-xmark",
                  onClick: closeEditModal
                })
              ])
            ]),
            _hoisted_12,
            _createElementVNode("div", { class: "wrap_button" }, [
              _createElementVNode("div", {
                class: "button_okay",
                onClick: editInfo
              }, " 수정 "),
              _createElementVNode("div", {
                class: "modal_cancel",
                onClick: closeEditModal
              }, " 취소 ")
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_13, [
      _createElementVNode("div", _hoisted_14, [
        _createVNode(_component_font_awesome_icon, {
          class: "chevron",
          icon: "fa-solid fa-bars",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (showMobileMenu()))
        }),
        _hoisted_15
      ]),
      _createElementVNode("div", _hoisted_16, [
        _createElementVNode("div", _hoisted_17, [
          _createElementVNode("div", null, [
            _createElementVNode("div", _hoisted_18, [
              _createElementVNode("div", _hoisted_19, [
                _hoisted_20,
                _createVNode(_component_a_select, {
                  ref: "select",
                  value: persona.value,
                  "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((persona).value = $event)),
                  class: "dropdown",
                  options: personaList.value,
                  onChange: personaHandleChange
                }, null, 8, ["value", "options"])
              ]),
              _createElementVNode("div", _hoisted_21, [
                _hoisted_22,
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((selectedAvatarDetail.value.world) = $event)),
                  placeholder: "Enter World"
                }, null, 512), [
                  [_vModelText, selectedAvatarDetail.value.world]
                ])
              ]),
              _createElementVNode("div", _hoisted_23, [
                _hoisted_24,
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((selectedAvatarDetail.value.era) = $event)),
                  placeholder: "Enter Era"
                }, null, 512), [
                  [_vModelText, selectedAvatarDetail.value.era]
                ])
              ]),
              _createElementVNode("div", _hoisted_25, [
                _hoisted_26,
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((selectedAvatarDetail.value.place) = $event)),
                  placeholder: "Enter Place"
                }, null, 512), [
                  [_vModelText, selectedAvatarDetail.value.place]
                ])
              ]),
              _createElementVNode("div", _hoisted_27, [
                _hoisted_28,
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((selectedAvatarDetail.value.happenings) = $event)),
                  placeholder: "Enter Happenings"
                }, null, 512), [
                  [_vModelText, selectedAvatarDetail.value.happenings]
                ])
              ]),
              _createElementVNode("div", _hoisted_29, [
                _hoisted_30,
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((selectedAvatarDetail.value.name) = $event)),
                  placeholder: "Enter Name"
                }, null, 512), [
                  [_vModelText, selectedAvatarDetail.value.name]
                ])
              ]),
              _createElementVNode("div", _hoisted_31, [
                _hoisted_32,
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((selectedAvatarDetail.value.age) = $event)),
                  placeholder: "Enter Age"
                }, null, 512), [
                  [_vModelText, selectedAvatarDetail.value.age]
                ])
              ]),
              _createElementVNode("div", _hoisted_33, [
                _hoisted_34,
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((selectedAvatarDetail.value.tribe) = $event)),
                  placeholder: "Enter Tribe"
                }, null, 512), [
                  [_vModelText, selectedAvatarDetail.value.tribe]
                ])
              ]),
              _createElementVNode("div", _hoisted_35, [
                _hoisted_36,
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((selectedAvatarDetail.value.gender) = $event)),
                  placeholder: "Enter Gender"
                }, null, 512), [
                  [_vModelText, selectedAvatarDetail.value.gender]
                ])
              ]),
              _createElementVNode("div", _hoisted_37, [
                _hoisted_38,
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((selectedAvatarDetail.value.work) = $event)),
                  placeholder: "Enter Work"
                }, null, 512), [
                  [_vModelText, selectedAvatarDetail.value.work]
                ])
              ]),
              _createElementVNode("div", _hoisted_39, [
                _hoisted_40,
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((selectedAvatarDetail.value.goal) = $event)),
                  placeholder: "Enter Goal"
                }, null, 512), [
                  [_vModelText, selectedAvatarDetail.value.goal]
                ])
              ]),
              _createElementVNode("div", _hoisted_41, [
                _hoisted_42,
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((selectedAvatarDetail.value.value) = $event)),
                  placeholder: "Enter Value"
                }, null, 512), [
                  [_vModelText, selectedAvatarDetail.value.value]
                ])
              ]),
              _createElementVNode("div", _hoisted_43, [
                _hoisted_44,
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((selectedAvatarDetail.value.motivation) = $event)),
                  placeholder: "Enter Motivation"
                }, null, 512), [
                  [_vModelText, selectedAvatarDetail.value.motivation]
                ])
              ]),
              _createElementVNode("div", _hoisted_45, [
                _hoisted_46,
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((selectedAvatarDetail.value.personality) = $event)),
                  placeholder: "Enter Personality"
                }, null, 512), [
                  [_vModelText, selectedAvatarDetail.value.personality]
                ])
              ]),
              _createElementVNode("div", _hoisted_47, [
                _hoisted_48,
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((selectedAvatarDetail.value.mbti) = $event)),
                  placeholder: "Enter MBTI"
                }, null, 512), [
                  [_vModelText, selectedAvatarDetail.value.mbti]
                ])
              ]),
              _createElementVNode("div", _hoisted_49, [
                _hoisted_50,
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((selectedAvatarDetail.value.favorite) = $event)),
                  placeholder: "Enter Favorite"
                }, null, 512), [
                  [_vModelText, selectedAvatarDetail.value.favorite]
                ])
              ]),
              _createElementVNode("div", _hoisted_51, [
                _hoisted_52,
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((selectedAvatarDetail.value.specialty) = $event)),
                  placeholder: "Enter Specialty"
                }, null, 512), [
                  [_vModelText, selectedAvatarDetail.value.specialty]
                ])
              ]),
              _createElementVNode("div", _hoisted_53, [
                _hoisted_54,
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((selectedAvatarDetail.value.topic) = $event)),
                  placeholder: "Enter Topic"
                }, null, 512), [
                  [_vModelText, selectedAvatarDetail.value.topic]
                ])
              ]),
              _createElementVNode("div", _hoisted_55, [
                _hoisted_56,
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((selectedAvatarDetail.value.speaking_habits) = $event)),
                  placeholder: "Enter Speaking Habits"
                }, null, 512), [
                  [_vModelText, selectedAvatarDetail.value.speaking_habits]
                ])
              ]),
              _createElementVNode("div", { class: "wrap_button" }, [
                _createElementVNode("div", {
                  class: "modal_cancel",
                  onClick: openModal
                }, " 삭제하기 "),
                _createElementVNode("div", {
                  class: "button_okay",
                  onClick: openEditModal
                }, " 수정하기 ")
              ])
            ])
          ])
        ])
      ])
    ])
  ], 64))
}
}

})